import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { SearchContainer } from 'components';

import { HeaderButtons } from 'components/HeaderButtons';

export const HeaderDesktop: FC = (): ReactElement => (
  <div className={styles.headerBackground}>
    <header className={styles.wrapper}>
        <div className={styles.header}>
            <div className={styles.headerMainItems}>
            <strong>DeepDAO is not currently updating data.</strong> The last update was on <strong>11.24.25.</strong> This site is a static snapshot meant to showcase the platform’s breadth. <strong>Do not use it for research, analysis, or decision-making.</strong> For inquiries: <strong>info@deepdao.io</strong>
                {/* <SearchContainer />
                <HeaderButtons /> */}
            </div>
        </div>
    </header>
  </div>
);
